var exports = {
  "U": "xe533113f--6894f8--buttons",
};

module.exports = exports;
